<template>
	<div class="receivelist-container">
		<div class="head">ADDRESS</div>

		<div class="receivelist-wrap">

			<div class="add-address-button" @click="$router.push('/receive')">
				<i class="iconfont ">&#xe626;</i> 
				<span>Add a new address</span>
			</div>
            
			<div  class="add-item-wrap">
				<div class="add-item" v-for="(item,index) in list.list" >
					<div class="top">
						<div class="lf">
							<ul>
								<li>
									<label>First Name：</label>{{item.first_name}}
								</li>
								<li>
									<label>Last Name：</label>{{item.last_name}}
								</li>
								<li>
									<label>Postcode ：</label>{{item.postcode}}
								</li>
								<li>
									<label>Email：</label><span>{{item.email}}</span>
								</li>
								<li>
									<label>Address：</label><span>{{item.address}}</span>
								</li>
								
							</ul>
						</div>
						<div class="rt" @click="gotoEdit(item)">
							<i class="iconfont">&#xe654;</i>
							<span>Edit</span>
						</div>
					</div>
					<div class="bottom">
						<button @click="setDefault(item)">

							<i class="iconfont" v-if="item.default==1">&#xe7e9;</i>
							<i class="iconfont" v-else>&#xe666;</i>

							<span>set as default</span>
						</button>
						<div class="rt">
							<button type="button" @click="del(item,index)">
								<i class="iconfont">&#xe609;</i>
								<span>Del</span>
							</button>

						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

    import { Toast , Dialog} from 'vant';

   


	export default {
		data() {
			return {
				
				list: [],
				loading: false
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			showToast(msg){
               this.global_variable.showToast(msg);
			},
			setDefault(item) {
				var app = this;
				this.$api("/user/default_address", {
					id: item.id
				}).then(function(res) {

					if (res.status == "200") {

						
                       app.showToast(res.msg)
						
						app.list.list.forEach(listItem => {
							listItem.default = 2;
						})
						item.default = 1;
					}

				})


			},
			del(item, index) {

				var app = this;


				this.global_variable.dialogConfirm({title:"Tips",message:"Delete address?"}).then(() => {
					  	app.loading = true;

					    app.$api("/user/delAddress", {
					  	    addr_id: item.id
						}).then(function(res) {
								app.loading = false;

								if (res.status == "200") {

									Toast.success(res.msg);

									app.list.list.splice(index, 1);
								}

						})
				})
  
			
			},
			gotoEdit(item) {

				this.$router.push({
					name: 'receive',
					params: {
						data: JSON.stringify(item)
					}
				})
			},
			getList() {
				var app = this;
                
                app.loading = true;

				this.$api("/user/getAddressList", {}).then(function(res) {

					app.loading = false;

					app.list = res.data;
	
				})
			}
		}
	}
</script>

<style lang="less" >
	

	.receivelist-container {
	
		.receivelist-wrap {
			.add-item {
				border: 1px solid #dcdddd;
				margin-top: 40px;
				border-radius: 6px;

				.top {
					padding: 40px;
					display: flex;
					border-bottom: 1px solid #dcdddd;
					justify-content: space-between;

					ul {
						width: 500px;

						li {
							margin-bottom: 20px;
							color: #666;
							line-height: 1.5;
							font-size: 16px;

							&:last-of-type {
								margin: 0;
							}

							label {
								width: 90px;
								display: inline-block;
								text-align: justify;
							}
						}
					}

					.rt {
						color: #9b9b9b;
						cursor: pointer;

						i {
							color: #9b9b9b;
							margin-right: 10px;
						}
					}

				}

				.bottom {
					padding: 20px 40px;
					display: flex;
					font-size: 16px;
					align-items: center;
					justify-content: space-between;

					>button {
						font-size: 16px;
						color: #666;

						i {
							margin-right: 10px;
							font-size: 30px;
							color: #90c31f;

						}
					}

					.rt {
						button {
							font-size: 16px;
							color: #9b9b9b;
						}

						i {
							color: #9b9b9b;
							margin-right: 10px;
						}
					}

				}
			}

			.add-address-button {
				line-height: 60px;
				border-radius: 30px;
				color: #fff;
				font-size: 16px;
				cursor: pointer;
				padding:0 20px;
				background-color: #90c31f;
			}
		}
	}

	@media screen and (max-width:768px) {
	  
		.receivelist-container { 

		  	.receivelist-wrap{
		  		
		  		.add-address-button{
	  			    line-height: 36px;
	  			    font-size:12px;
	  			    i{
	  			    	font-size:14px;
	  			    }
		  		}
		  		.add-item{
		  			margin-top:20px;
		  			.top{
		  				padding: 20px;
		  				ul{
		  					width:100%;
		  					li{
	  						    margin-bottom: 10px;
	  						    font-size: 12px;
		  					}
		  				}
		  			}
		  			.rt{
		  				span{
		  					display:none;
		  				}
		  			}
		  			.bottom{
		  				padding: 2% 4%;
		  				font-size: 12px;
		  				.rt{
                           button{
                           	  font-size: 12px; 
                           }
		  				}
		  				> button{
		  					font-size: 12px;
		  				    i{
			  					font-size:14px;
			  				}
		  				}
		  			}
		  		}

		  	}
		} 
	}
</style>



// WEBPACK FOOTER //
// src/components/ReceiveList.vue